import React from "react";
import { Link, useParams } from "react-router-dom";
import { dishes, findDish, fullName } from "../data/dishes";
import { findCategory } from "../data/menu";
import { findArticle } from "../data/articles";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import FoodImage from "../components/FoodImage";
import NotFoundPage from "./NotFoundPage";

export default function PairingPage() {
  const { slug } = useParams();
  const article = findArticle(slug);
  useTheme(dishes[0]);
  useDocumentTitle(article ? article.title : "Pairing not found");
  if (!article) return <NotFoundPage />;
  return (
    <article key={article.id}>
      <section className="ro-article-cover">
        <div className="ro-container">
          <h1>{article.title}</h1>
          <p className="ro-small">{article.category} · Pairing idea · 2 min read</p>
          <img src={article.image} alt={article.imageAlt} />
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container ro-article-content">
          <p>{article.body}</p>
          <h2>
            A little <span className="ro-outline">inspiration.</span>
          </h2>
          <p>{article.tip}</p>
          <Link className="ro-pill ro-pill--solid" to="/pairings">
            ← All pairings
          </Link>
        </div>
      </section>
      <section className="ro-section ro-tinted">
        <div className="ro-container">
          <h2 style={{ marginBottom: 40 }}>
            Explore these <span className="ro-outline">cravings.</span>
          </h2>
          {article.categorySlug && findCategory(article.categorySlug) && (
            <Link className="ro-pill ro-pill--solid" to={`/menu/c/${article.categorySlug}`} style={{ marginBottom: 40 }}>
              Browse {findCategory(article.categorySlug).name.toLowerCase()} on the full menu
            </Link>
          )}
          <div className="ro-related__grid">
            {article.dishIds.map((id) => {
              const d = findDish(id);
              return (
                <Link key={id} to={`/menu/${d.id}`} className="ro-card" style={{ "--ro-theme": d.colour, "--ro-pale": d.pale }}>
                  <div className="ro-card__tile">
                    <FoodImage dish={d} alt="" />
                  </div>
                  <h3>{fullName(d)}</h3>
                  <p>{d.desc}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </article>
  );
}
